/**
 * Helper functions for template labels localization
 */

/**
 * Get localized label for an item based on current language
 * Prioritizes label_ar if language is 'ar' and label_ar exists
 * @param item Object with label, label_ar, title, key properties
 * @param language Current language code ('en', 'ar', etc.)
 * @returns Localized label string
 */
export const getLocalizedLabel = (item: any, language: string): string => {
  if (language === 'ar' && item.label_ar) return item.label_ar
  if (language === 'ar' && item.description_ar) return item.description_ar
  return item.label || item.title || item.key || ''
}

/**
 * Get localized description for an item based on current language
 * Prioritizes description_ar if language is 'ar' and description_ar exists
 * @param item Object with description, description_ar properties
 * @param language Current language code ('en', 'ar', etc.)
 * @returns Localized description string
 */
export const getLocalizedDescription = (item: any, language: string): string => {
  if (language === 'ar' && item.description_ar) return item.description_ar
  return item.description || ''
}

/**
 * Get localized category name
 * @param category Object with name, name_ar properties
 * @param language Current language code
 * @returns Localized category name
 */
export const getLocalizedCategoryName = (category: any, language: string): string => {
  if (language === 'ar' && category.name_ar) return category.name_ar
  return category.name || ''
}
